import PaymentButton, { PaymentUIResult } from './PaymentButton';
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface PaymentDialogProps {
  open: boolean;
  item: string;
  price: number;
  currency: string;
  title?: string;
  message?: string;
  onClose: (result: PaymentUIResult, details: any) => void;
}

const PaymentDialog = (props: PaymentDialogProps) => {
  const [busy, setBusy] = useState(false);

  function handleButtonClick() {
    setBusy(true);
  }

  function handleComplete(result: PaymentUIResult, details: any) {
    setBusy(false);
    props.onClose(result, details);
  }

  return (
    <Dialog open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        {busy && <CustomLoadingProgress />}
        <DialogContentText>{props.message}</DialogContentText>
        <PaymentButton
          id="payment-dialog"
          item={props.item}
          price={props.price}
          currency={props.currency}
          onClick={handleButtonClick}
          onComplete={handleComplete}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => props.onClose('cancel', null)}
          color="primary"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog;
